import { clearAccessToken } from "@/redux/actions/auth-actions";
import { useSelector, useDispatch } from "react-redux";

const useAuth = () => {
  const dispatch = useDispatch();
  const { accessToken, user, roles, isAuthenticated, isInitialized } =
    useSelector((state) => state.auth);

  const logout = () => {
    dispatch(clearAccessToken());
  };

  return {
    accessToken,
    user,
    roles,
    isAuthenticated,
    isInitialized,
    logout,
  };
};

export default useAuth;
